module.exports = __webpack_public_path__ + "static/img/Shopify.045380b4.jpg";